import { getCurrentTopicSlug } from '@/utils/initializeData'

export default {
    computed: {
        $routeParams() {
            const params = { locale: this.$route.params.locale || 'zh-hant' }
            if (this.$route.params.year) {
                params.year = this.$route.params.year
            }
            return params
        },
        $topicSlug() {
            return getCurrentTopicSlug(this.$route.params)
        },
        $apiTopicSlug() {
            return typeof this.$topicSlug === 'string'
                ? this.$topicSlug.replace(/^topic-/, '')
                : this.$topicSlug
        },
    },
    methods: {
        $resolveRouteName(name) {
            if (!name) {
                return name
            }

            if (!this.$route.name || !this.$route.name.startsWith('topic-')) {
                return name
            }

            return name.startsWith('topic-') ? name : `topic-${name}`
        },
        $getLocale() {
            return this.$i18n.locale
        },
        $switchLanguage(locale) {
            var uriList = this.$route.path.split('/').filter(i => i)
            const isTopicRoute = uriList[1] === 'topic'

            if (isTopicRoute) {
                if (uriList.length >= 1) {
                    uriList[0] = locale
                }
            } else if (uriList.length >= 2) {
                uriList[1] = locale
            }

            if (this.$route.query != null) {
                if (uriList.length === 1) {
                    this.$router.push({ path: '/' + uriList.join('/') + '/' + locale, query: this.$route.query })
                } else {
                    this.$router.push({ path: '/' + uriList.join('/'), query: this.$route.query })
                }
            } else {
                this.$router.push('/' + uriList.join('/'))
            }
        }
    }
}
